import React from 'react';

import JournalTable from '../../common/JournalTable';
import PageTitle from '../../common/PageTitle';

import { fetchGetSuppliesExportTasks, fetchGetSuppliesReportById } from '../../../actions/supplies';
import { ORDERS_EXPORT_PAGE_LABELS, ORDERS_EXPORT_SEARCH_DATE_TYPE_OPTIONS } from '../../../config';
import { useAutoTranslation } from '../../../helpers/useAutoTranslation';

const ExportPage = () => {
  const { t } = useAutoTranslation();

  const handleGetTaskData = (taskData) => {
    let result = [];
    if (taskData.requestJson) {
      const parsed = JSON.parse(taskData.requestJson);
      result = [
        ...Object.keys(parsed)
          .map((key) => ({
            label: ORDERS_EXPORT_PAGE_LABELS[key],
            value: (() => {
              if (key === 'searchDateType') {
                return ORDERS_EXPORT_SEARCH_DATE_TYPE_OPTIONS.find((o) => o.value === parsed[key])
                  .label;
              }
              return typeof parsed[key] === 'boolean' ? (parsed[key] ? 'Да' : 'Нет') : parsed[key];
            })(),
          }))
          .filter((i) => i.label),
      ];
    }
    return result;
  };

  const handleShowReport = (task) => task.processingLog && task.processingLog.length;
  const handleShowSuccessReport = (task) => !handleShowReport(task) && task.fileUrl;

  return (
    <>
      <PageTitle title={t('Задачи экспорта поставок')} />
      <JournalTable
        matchingWithName
        processedLabel={t('Экспортировано')}
        newTaskLabel={t('Новый экспорт')}
        newTaskUrl={`/supplies/export/new`}
        taskName={t('Экспорт поставок (Excel)')}
        getTaskData={handleGetTaskData}
        getTasksAction={fetchGetSuppliesExportTasks}
        getTaskDataAction={fetchGetSuppliesReportById}
        showSummary={false}
        detailsTitle={t('Опции экспорта')}
        showReport={handleShowReport}
        showSuccessReport={handleShowSuccessReport}
        reportUrl="/supplies/export/report"
        taskTimePropName="startTime"
      />
    </>
  );
};

export default ExportPage;
